import config from '@app/config';
import * as Prismic from '@prismicio/client';

const accessToken = config.prismic.accessToken;
const apiEndpoint = config.prismic.apiEndpoint;

const Client = Prismic.createClient(apiEndpoint, { accessToken });

export default {
	getAllArticles: async () => {
		let articles = []; // store for articles
		let response = await Client.query(
			Prismic.Predicates.at('document.type', 'article'),
			{ pageSize: 30 }
		);
		articles.push(response.results); // add initial articles to store

		if (response.total_pages > 1) {
			// if theres more than 1 page of results, start looping through till we have all results
			const page_count = response.total_pages;
			for (let i = 2; i <= page_count; i++) {
				const page_response = await Client.query(
					Prismic.Predicates.at('document.type', 'article'),
					{ pageSize: 30, page: i }
				);
				articles.push(page_response.results); // add paginated  results to article store
			}
		}

		response.results = articles.flat(); // flatten array (merge all articles into a single array), then push into intial results object

		// If the Request Was Successful, Return Results
		if (response) {
			return response;
		}

		return null;
	},
};
